import { CancelCircle } from "src/assets/icons";
import {
  BACKGROUND_LIGHT,
  ERROR_COLOR,
  ERROR_DARK,
} from "src/constants/colors";
import { useApplication } from "./ApplicationContext";
import styled from "@emotion/styled";
import { APPLICATION_STATUS_KEYS } from "src/constants";

const BannerContainer = styled.div`
  display: flex;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 32px;
  background: ${ERROR_DARK};
  margin-top: 24px;
  color: ${BACKGROUND_LIGHT};
  font-size: 14px;
`;

export default () => {
  const {
    application: { application_status },
  } = useApplication();

  const isSubmissionFailed =
    (application_status ?? "") ===
    (APPLICATION_STATUS_KEYS["Submission failed"] as string);

  if (!isSubmissionFailed) {
    return null;
  }

  return (
    <BannerContainer>
      <CancelCircle
        fillColor={ERROR_COLOR}
        opacity="100"
        width={18}
        height={18}
      />
      <span>
        This application could not be sent. Please contact support for
        assistance.
      </span>
    </BannerContainer>
  );
};
